import React from "react";
import Routes from "../../../routes/data/DataForecasting";

class DataForecasting extends React.Component {
  render() {
    return (
      <Routes api={this.props.api} user={this.props.user}/>
    );
  }
}

export default DataForecasting;
